/**
 * Change label of button inside cookie form
 * All checkboxes are selected by default
 * If one checkbox is not checked label is changed
 */
export default class CookieButtonController {
    constructor() {
        /**
         * DOM Selectors
         * @type {{acceptAllLabel: string, cookieForm: string, acceptLabel: string}}
         */
        this.DOM = {
            cookieForm: ".js-cookie-form",
            acceptAllLabel: ".js-cookie-form-accept-all",
            acceptLabel: ".js-cookie-form-accept",
        };

        this.cookieForm = document.querySelector(this.DOM.cookieForm);
    }

    /**
     * Init
     */
    init() {
        if (this.cookieForm === null) {
            return;
        }
        this.changeButtonLabel();
    }

    /**
     * Change label
     * Checks if any checkbox is not selected and toggles label
     */
    changeButtonLabel() {
        const acceptAll = this.cookieForm.querySelector(
            this.DOM.acceptAllLabel,
        );
        const accept = this.cookieForm.querySelector(this.DOM.acceptLabel);
        const inputs = this.cookieForm.querySelectorAll("input[type=checkbox]");

        for (let i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener("change", () => {
                if (
                    this.cookieForm.querySelectorAll(
                        "input[type=checkbox]:checked",
                    ).length !== inputs.length
                ) {
                    accept.style.display = "block";
                    acceptAll.style.display = "none";
                } else {
                    accept.style.display = "none";
                    acceptAll.style.display = "block";
                }
            });
        }
    }
}
